export function sortState(newState) {
  const releases = newState.get('releases').sort((releaseA, releaseB) => {
    const dateA =
      newState.get('viewOptions').get('externalDates') &&
      !releaseA.get('externalDateResolutionSync')
        ? releaseA.get('externalReleaseDate')
        : releaseA.get('releaseDate');

    const dateB =
      newState.get('viewOptions').get('externalDates') &&
      !releaseB.get('externalDateResolutionSync')
        ? releaseB.get('externalReleaseDate')
        : releaseB.get('releaseDate');

    // If release dates are the same, use development started on
    // If development started on the same, use release name
    // This mimics what is in the model
    if (dateA === dateB) {
      const devStartA = releaseA.get('developmentStartedOn') || '';
      const devStartB = releaseB.get('developmentStartedOn') || '';
      if (devStartA === devStartB) {
        return releaseA.get('name') > releaseB.get('name');
      }
      return devStartA > devStartB;
    }
    return dateA > dateB;
  });

  return newState.set('releases', releases);
}

export function recalculateAutomaticDates(newState) {
  const minDates = [];
  const maxDates = [];
  const externalDates = newState.get('viewOptions').get('externalDates');

  const length = newState.get('releases').count();
  for (let i = 0; i < length; i++) {
    const release = newState.get('releases').get(i);
    if (externalDates) {
      minDates.push(release.get('externalReleaseRangeFrom'));
      maxDates.push(release.get('externalReleaseRangeTo'));
    } else {
      minDates.push(release.get('releaseDate'));
      maxDates.push(release.get('releaseDate'));
    }
  }

  newState = newState.setIn(
    ['viewOptions', 'dates', 'automaticMinDate'],
    minDates.sort()[0]
  );
  newState = newState.setIn(
    ['viewOptions', 'dates', 'automaticMaxDate'],
    maxDates.sort()[maxDates.length - 1]
  );

  return newState;
}

export function addOrRemoveItem(state, path, add, fieldId) {
  if (path == null) {
    path = [];
  }
  if (add) {
    return state.updateIn(path, function (list) {
      if (list.includes(fieldId)) {
        return list;
      } else {
        return list.push(fieldId);
      }
    });
  } else {
    const index = state.getIn(path).indexOf(fieldId);
    if (index >= 0) {
      return state.deleteIn(path.concat([index]));
    }
  }
}

export function updateBookmark(bookmarkId, timelineType, data) {
  fetch(`/bookmarks/${timelineType}_timelines/` + bookmarkId, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': window.csrfToken(),
    },
    body: JSON.stringify({
      reactive_client_id: window.reactiveClientId(),
      [`bookmarks_${timelineType}_timeline`]: data,
    }),
  });
}

export function toggleFeature(show, bookmarkId, featureId) {
  fetch(
    '/bookmarks/project_timelines/' + bookmarkId + '/features/' + featureId,
    {
      method: show ? 'POST' : 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': window.csrfToken(),
      },
      body: JSON.stringify({
        reactive_client_id: window.reactiveClientId(),
      }),
    }
  );
}

export function toggleEpic(show, bookmarkId, epicId) {
  fetch('/bookmarks/epic_timelines/' + bookmarkId + '/epics/' + epicId, {
    method: show ? 'POST' : 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': window.csrfToken(),
    },
    body: JSON.stringify({
      reactive_client_id: window.reactiveClientId(),
    }),
  });
}

export function addAllFeatures(bookmarkId, releaseId) {
  fetch(
    '/bookmarks/project_timelines/' + bookmarkId + '/releases/' + releaseId,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': window.csrfToken(),
      },
      body: JSON.stringify({
        reactive_client_id: window.reactiveClientId(),
      }),
    }
  );
}

export function addAllEpics(bookmarkId, releaseId) {
  fetch('/bookmarks/epic_timelines/' + bookmarkId + '/releases/' + releaseId, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': window.csrfToken(),
    },
    body: JSON.stringify({
      reactive_client_id: window.reactiveClientId(),
    }),
  });
}

export function removeRelease(bookmarkId, releaseId) {
  fetch(
    '/bookmarks/project_timelines/' + bookmarkId + '/releases/' + releaseId,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': window.csrfToken(),
      },
      body: JSON.stringify({
        reactive_client_id: window.reactiveClientId(),
      }),
    }
  );
  return window.ReleasePicker.deselectRelease(releaseId);
}
